import { Component, HostListener, OnInit, isDevMode } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { ApiService } from './_utils/api/api.service';
import { PushNotificationService } from './_utils/push-notification/push-notification.service';
import { PwaService } from './_utils/pwa/pwa.service';
import { StorageService } from './_utils/storage/storage.service';
import { LAST_ACCESS_NAME } from './app.constants';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    <router-outlet></router-outlet>
  `
})
export class App implements OnInit {
  public PWA_VERSION: string = '';
  swBroadcastChannel;

  constructor(
    private pwaService: PwaService,
    protected router: Router,
    private pushNotificationService: PushNotificationService,
    private storageService: StorageService,
    private apiService: ApiService,
    private meta: Meta
  ) {
    this.pushNotificationService.onTokenChanges(); // check for token changes

    if (!isDevMode()) this.pwaService.checkForUpdate(); // check for pwa updates

    // this broadcast channel is used to receive notifications from the service worker
    this.swBroadcastChannel = new BroadcastChannel('fcm-sw-broadcastChannel');
    this.swBroadcastChannel.onmessage = (message) => {
      console.log('message received from service worker', message);
      if (
        message.data &&
        message.data.action === 'redirect-from-notificationclick'
      ) {
        console.log('Redirect from notification to ' + message.data.url);
        router.navigate([message.data.url], { queryParams: { reload: true } });
      }
    };
  }

  ngOnInit(): void {
    this.applyCrawlerIndexingRule();
  }

  private applyCrawlerIndexingRule(): void {
    this.apiService.getCompany().subscribe({
      next: (response) => {
        if (response?.data?.app_indexable == false)
          this.meta.updateTag({ name: 'robots', content: 'noindex,nofollow' });
        else
          this.meta.updateTag({ name: 'robots', content: 'index,follow' });
      },
      error: (error) => {
        console.error('Failed to load company data for indexing rule', error);
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    // Save last access date to storage when the user leaves the app
    // this is used to check if (in the next session) if there is new
    // offers available
    this.storageService.saveValue(LAST_ACCESS_NAME, Date.now());
  }
}
